<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title"><i class="el-icon-school"></i> 部门列表</div>
    <div class="main-shadow-box">
      <el-row style="margin-bottom: 10px;">
        <el-button @click="openAdd()" style="float: right" type="primary">新增</el-button>
      </el-row>
      <el-table :data="list" size="medium">
        <el-table-column prop="no" label="编号"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="remark" label="备注" width="300"></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template v-slot="s">{{s.row.createTime | date_time}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="s">
            <el-button @click="openUpdate(s.row)">修改</el-button>
            <el-button @click="openRemove(s.row)" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-dialog :visible.sync="addVisible" :department="currentDepartment"></add-dialog>
    <update-dialog :visible.sync="updateVisible" :department="currentDepartment"></update-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import addDialog from './add'
import updateDialog from './update'

export default {
  components: {
    addDialog,
    updateDialog
  },
  data() {
    return {
      addVisible: false,
      updateVisible: false,
      currentDepartment: {},
    };
  },
  computed: {
    ...mapState("department", ["list"])
  },
  methods: {
    ...mapActions({load: 'department/list'}),
    openUpdate(row){
      this.currentDepartment = {...row}
      this.addVisible = false
      this.updateVisible = true
    },
    openAdd(){
      this.currentDepartment = {
        no: "",
        name: "",
        remark: ""
      }
      this.addVisible = true
      this.updateVisible = false
    },
    openRemove(row){
      this.$confirm(`是否确定删除 ${row.name} ？`, { type: "warning" })
        .then(() => this.remove(row.id))
        .then(() => {
          this.$message("移除成功")
        });
    }
  },
  mounted() {
    this.load()
  }
};
</script>
